var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNpm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 24.859 155.706 L 479.42 155.706 L 479.42 407.929 L 252.139 407.929 L 252.139 449.974 L 151.135 449.974 L 151.135 407.929 L 24.859 407.929 L 24.859 155.706 Z M 50.11 365.888 L 100.612 365.888 L 100.612 239.795 L 125.863 239.795 L 125.863 365.888 L 151.135 365.888 L 151.135 197.749 L 50.087 197.749 L 50.087 365.888 L 50.11 365.888 Z M 176.387 197.749 L 176.387 407.929 L 226.888 407.929 L 226.888 365.888 L 277.391 365.888 L 277.391 197.749 L 176.387 197.749 Z M 302.642 197.749 L 302.642 365.888 L 353.144 365.888 L 353.144 239.795 L 378.417 239.795 L 378.417 365.888 L 403.647 365.888 L 403.647 239.795 L 428.918 239.795 L 428.918 365.888 L 454.145 365.888 L 454.145 197.749 L 302.642 197.749 Z",
    style: {
      fill: "rgb(140, 140, 140)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 252.139 328.588 L 229.411 328.588 L 229.411 236.631 L 252.139 236.631 L 252.139 328.588 Z",
    style: {
      fill: "rgb(140, 140, 140)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpm);
export default __webpack_public_path__ + "static/media/npm.af3a16943f24c7a36273d96dc10dd568.svg";
export { ForwardRef as ReactComponent };